import React, { Component } from 'react';
import { ImageUpload } from 'components';
import { message, Row, Col, Modal } from 'antd';
import defaultImg from 'images/default-component-preview.png';
import './index.less';

class ImageField extends Component {
	constructor (props) {
		super(props);
		this.state = {};
	}

	onChange = ({file, fileList}) => {
		const {props} = this;
		if (file.status === 'done') {
			message.success(`${file.name} 上传成功`);
		} else if (file.status === 'error') {
			message.error(`${file.name} 上传失败`);
		}
		props.onChange && props.onChange(fileList);
	}

	render () {
		const {props, state} = this;
		const {fileList = [], viewOnly} = props;
		const prefixClass = 'form-group-img-Field';
		let {previewVisible, previewImage} = state;

		return (
			viewOnly ? (<Row className={prefixClass}>
				{
					(fileList.length ? fileList : [{url: defaultImg, defaultFlag: true}]).map(v => {
						return (
							<Col span={4}>
								<div className={`${prefixClass}-wrap`}>
									<img
										src={v.url}
										className={!v.defaultFlag ? `${prefixClass}-wrap-cursor` : ''}
										onClick={() => {
											if (!v.defaultFlag) {
												this.setState({
													previewImage: v.url,
													previewVisible: true
												});
											}
										}
										}/>
								</div>
							</Col>
						);
					})
				}
				<Modal visible={previewVisible} footer={null} onCancel={() => {
					this.setState({
						previewVisible: false
					});
				}}>
					<img src={previewImage} style={{width: '100%'}}/>
				</Modal>
			</Row>
			)
				: <ImageUpload
					fileList={fileList}
					limitCount={props.limitCount}
					limitPerSize={5 * 1024 * 1024}
					onChange={ this.onChange }
				/>
		);
	}
}

export default ImageField;
